<template>
  <div class="edit-table">
    <vxe-toolbar v-if="!disabled">
      <template v-slot:buttons>
        <vxe-button @click="addTable">新增</vxe-button>
        <vxe-button @click="deleteTable">清空</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-table ref="xTable" resizable show-overflow :data="subjectList" :edit-config="{
      trigger: 'click',
      mode: 'cell',
    }">
      <vxe-table-column min-width="100" field="countryName" title="国"></vxe-table-column>
      <vxe-table-column min-width="100" field="provinceName" title="省"></vxe-table-column>
      <vxe-table-column min-width="100" field="cityName" title="市"></vxe-table-column>
      <vxe-table-column min-width="100" field="districtName" title="区"></vxe-table-column>

      <vxe-column title="操作" width="80" v-if="!disabled">
        <template #default="{ row }">
          <template>
            <span @click="deletRow(row)" style="color: red; cursor: pointer">删除</span>
          </template>
        </template>
      </vxe-column>
    </vxe-table>
    <!-- 弹框 -->
    <adressModal ref="adressModalRef" @onOk="addList" />
  </div>
</template>

<script>

import adressModal from './adress.vue';

export default {
  name: 'SalesArea',
  components: {
    adressModal,
  },
  props: {
    value: Array,
    disabled: Boolean,
  },
  watch: {
    value(e) {
      this.subjectList = e;
    },
  },
  data() {
    return {
      subjectList: [], //
    };
  },
  mounted() {

  },
  methods: {
    addList(e) {
      const selectData = e.map((item) => ({
        ...item,
        countryName: item.pcountryName,
      }));
      this.subjectList = selectData;
      this.$emit('change', selectData);
      this.$emit('input', selectData);
    },
    // 删除行
    deletRow(row) {
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refs.xTable.remove(row);
        this.subjectList.forEach((item, index) => {
          if (item.id === row.id) {
            this.subjectList.splice(index, 1);
          }
        });
        this.$emit('change', this.subjectList);
        this.$emit('input', e);
        this.$message({ type: 'success', message: '删除成功!' });
      });
    },

    // 清空列表
    deleteTable() {
      this.$refs.xTable.remove();
      this.value.data = [];
      this.subjectList = [];
      this.$emit('clear');
    },

    // 新增
    addTable() {
      const arr = this.subjectList.map((val) => {
        const arr1 = [];
        arr1.push(val.countryCode || '00');
        if (val.provinceCode) {
          arr1.push(val.provinceCode);
        }
        if (val.cityCode) {
          arr1.push(val.cityCode);
        }
        if (val.districtCode) {
          arr1.push(val.districtCode);
        }
        return arr1;
      });
      console.log(arr);
      this.$refs.adressModalRef.panelValue = arr;
      this.$refs.adressModalRef.modalConfig.visible = true;
    },

  },
};
</script>

<style lang="less" scoped>
</style>
